import React, { ReactNode } from "react"
import styles from "./PairSettingsControl.module.scss"
import { CloseButton } from "react-bootstrap"

export interface PairSettingsControlProps {
    id: string
    keyControl: ReactNode
    valueControl: ReactNode
    onDelete: () => void
    disabled?: boolean
    testId?: string
}

const PairSettingsControl: React.FC<PairSettingsControlProps> = props => {
    const { id, keyControl, valueControl, onDelete, disabled, testId } = props

    return (
        <div className={styles.pairSettingsControl} data-testid={testId}>
            {keyControl}
            {valueControl}
            <CloseButton
                className={styles.pairSettingsControl__closeIcon}
                onClick={onDelete}
                disabled={disabled}
                data-testid={testId ? `${testId}-remove-button` : `${id}-remove-button`}
            />
        </div>
    )
}

export default PairSettingsControl
